(function () {
  'use strict';

  angular
    .module('messageAdmin')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('messageAdmin', {
        url: '/message-admin',
        views: {
          'messageAdminView': {
            templateUrl: 'message-admin/views/message-admin.tpl.html',
            controller: 'MessageAdminCtrl',
            controllerAs: 'messageAdmin'
          }
        }
      });
  }
}());
